import React from "react";
import { Fade } from "react-reveal";
import QuickSelect from "../QuickSelect/QuickSelect";
import { completeSurvey } from "../../AppContainer";
import "./ChatMessages.css";

const UrlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

const ChatMessages = ({ conversation, possibleAnswers, sendReplyQuestion }) => {
  return (
    <div className="chat-text-container">
      <div className="chat-text">
        {
          conversation.messages.map((m, i) => !m.from ? (
            <Fade bottom duration={300} key={i}>
              <div className="chat-message-left-container" key={i}>
                <div className="chat-message-left" dangerouslySetInnerHTML={m.message}/>
              </div>
            </Fade>
          ) : (
            <Fade bottom duration={300} key={i}>
              <div className="chat-message-right-container" key={i}>
                <div className="chat-message-right">
                  {m.message}
                </div>
              </div>
            </Fade>
          ))
        }

        <div className="chat-quick-select">
          {possibleAnswers.map((answer, i) => (
            <QuickSelect key={i} answer={answer.toString()} onClick={(answer) => sendReplyQuestion(answer)}/>
          ))}
        </div>

        <AlwaysScrollToBottom />
      </div>
    </div>
  );
};

const AlwaysScrollToBottom = () => {
  const scrollerRef = React.useRef();
  React.useEffect(() => scrollerRef.current.scrollIntoView());
  return <div className="chat-scroll-to-bottom" ref={scrollerRef} />;
};

export const replaceResponseUrlsWithLinks = (resp) => {
  for (let index in resp.responses) {
    let matches = resp.responses[index].match(UrlRegex);
    if (!matches) { continue; }
    for (let url of matches) {
      // Only convert the url to a link if it's not already withing a link
      if (resp.responses[index].indexOf("href") === -1) {
        resp.responses[index] = resp.responses[index].replace(url, unescape("<a target=\"blank\" href=\"" + url + "\">" + url + "</a>"));
      }
    }
  }
};

export const replaceOngoingConversationUrlsWithLinks = (messages) => {
  for (let index in messages) {
    if (typeof messages[index].content != "string") {
      continue;
    }
    let matches = messages[index].content.match(UrlRegex);
    if (!matches) { continue; }
    for (let url of matches) {
      // Only convert the url to a link if it's not already withing a link
      if (messages[index].content.indexOf("href") === -1) {
        messages[index].content = messages[index].content.replace(url, unescape("<a target=\"blank\" href=\"" + url + "\">" + url + "</a>"));
      }
    }
  }
};

export default ChatMessages;
